import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GratefulDB, { Chords, Entry } from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import SearchResultItem from "../shared/SearchResultItem";
import { useNavUtils } from "../shared/useNavUtils";
import "./SearchResults.scss";

const SearchResults: React.FC = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const noResultsImage = require(`../../images/${process.env.REACT_APP_NO_RESULTS_IMAGE}`);

  const params = useParams();
  const navUtils = useNavUtils();
  const gratefulDB = useContext<GratefulDB>(GratefulDBContext);

  const [results, setResults] = useState<Entry[]>();

  useEffect(() => {
    if (params.term) {
      gratefulDB.search(params.term, params.year).then((entries) => {
        setResults(entries);
      });
    } else {
      setResults([]);
    }
  }, [params.term, params.year]);

  const [chordResults, setChordResults] = useState<Chords[]>();

  useEffect(() => {
    if (params.term && params.term.length >= 3) {
      gratefulDB.searchChords(params.term).then((chords) => {
        setChordResults(chords);
      });
    } else {
      setChordResults([]);
    }
  }, [params.term]);

  const noResults = (
    <div className="ui center aligned container no-results">
      <img className="ui centered image" src={noResultsImage} />
      <h1 className="ui header">
        No matching shows found.
        <div className="sub header">
          Please make sure your query is spelled correctly
          {params.year ? " or try removing filters" : ""}.
        </div>
      </h1>
    </div>
  );

  return (
    <div className="ui container SearchResults">
      {chordResults && chordResults.length > 0 ? (
        <div className="ui segment chords">
          <i className="music icon" />
          <b className="header">{process.env.REACT_APP_CHORDS_SOURCE}</b>
          {chordResults.map((chords) => (
            <a
              className="entry"
              onClick={() => navUtils.chords(chords.identifier)}
              key={chords.identifier}
            >
              {chords.title}
            </a>
          ))}
        </div>
      ) : null}
      <div className="ui divided link items">
        {results
          ? results.map((entry) => (
              <SearchResultItem entry={entry} key={entry.identifier} />
            ))
          : null}
      </div>
      {results && !results.length ? noResults : null}
    </div>
  );
};

export default SearchResults;
